import React, { useEffect, useState } from "react";
import InvestorForm from "../components/InvestorForm";
import axios from "axios";

function LoginPage() {
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const id = sessionStorage.getItem("invitationCodeId");

    if (!id) {
      setError("Missing invitation ID. Please log in again.");
      setUserData({}); // Still allow form to render
      return;
    }

    axios
      .get(`https://apiv1.worknotion.com/investorsProgram/getInvestorProfileByInvitationId?invitationCodeId=${id}`)
      .then((response) => {
        const data = response.data;

        if (!data) {
          // No data found, allow form with empty values
          setUserData({});
          return;
        }

        const formattedData = {
          id: data.id || "",
          fullName: data.fullLegalName || "",
          dob: data.dateOfBirth || "",
          birthCountry: data.countryOfBirth || "",
          citizenship: data.countryOfCitizenship || "",
          immigrationStatus: data.immigrationStatus || "",
          passport: data.passportNumber || "",
          submitted: typeof data.submitted === "boolean" ? data.submitted : "",

          ...Object.fromEntries(
            (data.dependents || []).flatMap((dep, i) => [
              [`depId${i}`, dep.id || ""],
              [`depName${i}`, dep.fullName || ""],
              [`depRelation${i}`, dep.relationship || ""],
              [`depDob${i}`, dep.dateOfBirth || ""],
              [`depBirthCountry${i}`, dep.countryOfBirth || ""],
              [`depCitizenship${i}`, dep.countryOfCitizenship || ""],
            ])
          ),

          investmentAmount: data.investmentAmount?.toString() || "",

          ...Object.fromEntries(
            (data.sourceOfFunds || []).flatMap((fund, i) => [
              [`amount_${i}`, fund.amountUsd?.toString() || "0"],
              [`support_${i}`, fund.supportingDocsAvailable ? "Yes" : "No"],
            ])
          ),
          
          sourceOfFunds: data.sourceOfFunds || [],

          // totalFunds: data.investmentAmount?.toString() || "",
          notes: data.additionalNote?.notes || "",
        };

        setUserData(formattedData);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        // Even on error, render form with empty values
        setUserData({});
      });
  }, []);

  if (userData === null) return <p className="text-center mt-5">Loading...</p>;

  return <InvestorForm initialData={userData} />;
}

export default LoginPage;
